/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersactionfailed2Inputs */

const en_membersactionfailed2 = /** @type {(inputs: Membersactionfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That didn't work. Please try again.`)
};

const de_membersactionfailed2 = /** @type {(inputs: Membersactionfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das hat nicht geklappt. Bitte versuch es noch einmal.`)
};

/**
* | output |
* | --- |
* | "That didn't work. Please try again." |
*
* @param {Membersactionfailed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersactionfailed2 = /** @type {((inputs?: Membersactionfailed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersactionfailed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersactionfailed2(inputs)
	return de_membersactionfailed2(inputs)
});
export { membersactionfailed2 as "membersActionFailed" }